import { Shield, Crown, BadgeCheck } from 'lucide-react';

const badgeConfig = {
  founding_creator: {
    label: 'Founding Creator',
    icon: Crown,
    className: 'text-amber-400',
    bgClassName: 'bg-amber-400/10 border-amber-400/30',
  },
  founding_member: {
    label: 'Founding Member',
    icon: Shield,
    className: 'text-slate-300',
    bgClassName: 'bg-slate-300/10 border-slate-300/30',
  },
  verified: {
    label: 'Verified',
    icon: BadgeCheck,
    className: 'text-sky-400',
    bgClassName: 'bg-sky-400/10 border-sky-400/30',
  },
};

export const VerifiedBadge = ({ size = 'sm' }) => {
  const sizeMap = { xs: 'w-3.5 h-3.5', sm: 'w-4 h-4', md: 'w-5 h-5' };
  return (
    <BadgeCheck
      className={`${sizeMap[size]} text-sky-400 shrink-0`}
      data-testid="verified-badge"
    />
  );
};

export const RoleBadge = ({ role, size = 'sm' }) => {
  const config = badgeConfig[role];
  if (!config || role === 'verified') return null;

  const Icon = config.icon;
  const sizeMap = { xs: 'w-3 h-3', sm: 'w-3.5 h-3.5', md: 'w-4 h-4' };

  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full border text-[10px] uppercase tracking-wider font-medium ${config.bgClassName} ${config.className}`}
      data-testid={`role-badge-${role}`}
    >
      <Icon className={sizeMap[size]} />
      {size !== 'xs' && <span>{config.label}</span>}
    </span>
  );
};

export const UserBadges = ({ role, badges = [], isVerified = false, size = 'sm', showRole = true }) => {
  const hasBadges = (role && role !== 'member') || isVerified;
  if (!hasBadges) return null;

  return (
    <span className="inline-flex items-center gap-1.5" data-testid="user-badges">
      {isVerified && <VerifiedBadge size={size} />}
      {showRole && role && role !== 'member' && <RoleBadge role={role} size={size} />}
    </span>
  );
};

export const ProfileBadges = ({ role, badges = [], isVerified = false }) => {
  const hasBadges = (role && role !== 'member') || isVerified;
  if (!hasBadges) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mt-3" data-testid="profile-badges">
      {isVerified && (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-sky-400/30 bg-sky-400/10 text-sky-400 text-xs uppercase tracking-wider font-medium">
          <BadgeCheck className="w-4 h-4" />
          Verified Creator
        </span>
      )}
      {role === 'founding_creator' && (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-amber-400/30 bg-amber-400/10 text-amber-400 text-xs uppercase tracking-wider font-medium">
          <Crown className="w-4 h-4" />
          Founding Creator
        </span>
      )}
      {role === 'founding_member' && (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-slate-300/30 bg-slate-300/10 text-slate-300 text-xs uppercase tracking-wider font-medium">
          <Shield className="w-4 h-4" />
          Founding Member
        </span>
      )}
    </div>
  );
};
